const doc = [({"en":({"js":({"admin":({"surveys":({"nav":({"judges":"Judges"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;